module.exports = __webpack_public_path__ + "img/18.63f3a238.jpg";